/**
 * Human-readable customer name. Companies have no last name (it's null), so a
 * naive `${firstName}, ${lastName}` renders "Company, null". Join only the
 * present parts.
 */
export function customerName(
    c: { firstName?: string | null; lastName?: string | null } | null | undefined,
    separator = " ",
): string {
    if (!c) {
        return "";
    }
    return [c.firstName, c.lastName].filter((part) => part != null && part !== "").join(separator);
}
